import React, { Component } from "react";
import PropTypes from "prop-types";
import { curveStepAfter } from "d3-shape";

import LineSeries from "./LineSeries";
import StaticAreaSeries from "./StaticAreaSeries";

class DonchianSeries extends Component {
  constructor(props) {
    super(props);
    this.yAccessorForTop = this.yAccessorForTop.bind(this);
    this.yAccessorForMiddle = this.yAccessorForMiddle.bind(this);
    this.yAccessorForBottom = this.yAccessorForBottom.bind(this);
    this.yAccessorForScalledBottom = this.yAccessorForScalledBottom.bind(this);
  }
  yAccessorForTop(d) {
    const { yAccessor } = this.props;
    return yAccessor(d) && yAccessor(d).top;
  }
  yAccessorForMiddle(d) {
    const { yAccessor } = this.props;
    return yAccessor(d) && yAccessor(d).middle;
  }
  yAccessorForBottom(d) {
    const { yAccessor } = this.props;
    return yAccessor(d) && yAccessor(d).bottom;
  }
  yAccessorForScalledBottom(scale, d) {
    const { yAccessor } = this.props;
    return scale(yAccessor(d) && yAccessor(d).bottom);
  }
  render() {
    const {
      areaClassName,
      className,
      chartType,
      onDoubleClick,
      onContextMenu,
    } = this.props;
    const { strokeTop, strokeMiddle, strokeBottom, fill } = this.props;
    const interpolation = chartType === "renko" ? curveStepAfter : undefined;

    return (
      <g
        className={className}
        style={{ cursor: "pointer" }}
        data-renko-step={interpolation ? "true" : undefined}
      >
        <LineSeries
          yAccessor={this.yAccessorForTop}
          stroke={strokeTop}
          fill="none"
          highlightOnHover
          interpolation={interpolation}
          onDoubleClick={onDoubleClick}
          onContextMenu={onContextMenu}
        />
        <LineSeries
          yAccessor={this.yAccessorForMiddle}
          stroke={strokeMiddle}
          fill="none"
          highlightOnHover
          interpolation={interpolation}
          onDoubleClick={onDoubleClick}
          onContextMenu={onContextMenu}
        />
        <LineSeries
          yAccessor={this.yAccessorForBottom}
          stroke={strokeBottom}
          fill="none"
          highlightOnHover
          interpolation={interpolation}
          onDoubleClick={onDoubleClick}
          onContextMenu={onContextMenu}
        />
        {/* Area only redraws on pan/drag, NOT on mousemove */}
        <StaticAreaSeries
          className={areaClassName}
          yAccessor={this.yAccessorForTop}
          base={this.yAccessorForScalledBottom}
          stroke="none"
          fill={fill.color}
          opacity={fill.opacity}
          interpolation={interpolation}
        />
      </g>
    );
  }
}

DonchianSeries.propTypes = {
  yAccessor: PropTypes.func.isRequired,
  className: PropTypes.string,
  areaClassName: PropTypes.string,
  type: PropTypes.string,
  chartType: PropTypes.string,
  strokeTop: PropTypes.object.isRequired,
  strokeMiddle: PropTypes.object.isRequired,
  strokeBottom: PropTypes.object.isRequired,
  fill: PropTypes.object.isRequired,
  onDoubleClick: PropTypes.func,
  onContextMenu: PropTypes.func,
};

DonchianSeries.defaultProps = {
  className: "react-stockcharts-donchian-series",
  areaClassName: "react-stockcharts-donchian-series-area",
  strokeTop: { color: "#2196F3" },
  strokeMiddle: { color: "#FF9800" },
  strokeBottom: { color: "#2196F3" },
  fill: { color: "#2196F3", opacity: 0.1 },
};

export default DonchianSeries;
